import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(columnsStyles, {
    container: {
        gap: 20,
    },
    leftColumnGridItem: {
        width: [12, 12, 3, 3, 3],
        css: css`
            background: #f1f6fb;
            border-radius: 4px;
            padding: 0;
            height: fit-content;
        `,
    },
    leftColumnTableViewGridItem: {
        width: [12, 12, 0, 0, 0],
    },
    rightColumnGridItem: {
        width: [12, 12, 9, 9, 9],
        css: css`
            padding: 0 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0;
                    `,
                    css`
                        padding: 0;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    rightColumnTableViewGridItem: {
        width: 12,
    },
});
